import { colours } from "@shared/ui.design-system";

export const scrollBarCss = {
  "::-webkit-scrollbar": {
    height: "4px"
  },
  "::-webkit-scrollbar-track": {
    background: colours.secondary.warm,
    margin: { base: "0 24px", md: "0 80px", lg: "0 120px" }
  },
  "::-webkit-scrollbar-thumb": {
    backgroundColor: colours.primary.medium,
    borderRadius: "2px",
    border: "2px solid onratechange",
    margin: { base: "0 24px", md: "0 80px", lg: "0 120px" }
  }
};
